"use client";

import { useLoadConfig } from "@/domains/config/hooks/useLoadConfig";

export function ClientConfigLoader() {
  useLoadConfig();
  return null;
}
